const { SUPPORTED_WIRE_COUNTRIES } = require('./supportedWireCountries')
const { SUPPORTED_CHECK_COUNTRIES } = require('./supportedCheckCountries')

const COUNTRY_CODES = [
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AO',
  'AQ',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BV',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HM',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NR',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PN',
  'PR',
  'PS',
  'PT',
  'PW',
  'PY',
  'QA',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SS',
  'ST',
  'SV',
  'SX',
  'SY',
  'SZ',
  'TC',
  'TD',
  'TF',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'UM',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WS',
  'YE',
  'YT',
  'ZA',
  'ZM',
  'ZW',
]

const CURRENCY = ['USD', 'CAD']

const REGEX = {
  ALPHANUMERIC: /^[a-zA-Z0-9]*$/,
  // eslint-disable-next-line no-useless-escape
  EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  NAME: /^[\p{Ll}\s\w'.-]+$/u,
  NUMERIC: /^[0-9]+$/,
  PHONE: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})\s*$/,
  POSTAL_CODE_US: /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/,
  POSTAL_CODE_CA: /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/,
  POSTAL_CODE_AD: /^(AD\d{3})$/,
  POSTAL_CODE_AM: /^((37)?\d{4})$/,
  POSTAL_CODE_AR: /^(([A-HJ-NP-Z])?\d{4}([A-Z]{3})?)$/,
  POSTAL_CODE_AS: /^(96799)$/,
  POSTAL_CODE_AT: /^(\d{4})$/,
  POSTAL_CODE_AU: /^(\d{4})$/,
  POSTAL_CODE_AX: /^(22\d{3})$/,
  POSTAL_CODE_AZ: /^(\d{4})$/,
  POSTAL_CODE_BA: /^(\d{5})$/,
  POSTAL_CODE_BB: /^((BB\d{5})?)$/,
  POSTAL_CODE_BD: /^(\d{4})$/,
  POSTAL_CODE_BE: /^(\d{4})$/,
  POSTAL_CODE_BG: /^(\d{4})$/,
  POSTAL_CODE_BH: /^(((1[0-2]|[2-9])\d{2})?)$/,
  POSTAL_CODE_BM: /^([A-Z]{2} ?[\dA-Z]{2})$/,
  POSTAL_CODE_BN: /^([A-Z]{2} ?\d{4})$/,
  POSTAL_CODE_BR: /^(\d{5}-?\d{3})$/,
  POSTAL_CODE_BY: /^(\d{6})$/,
  POSTAL_CODE_CC: /^(6799)$/,
  POSTAL_CODE_CH: /^(\d{4})$/,
  POSTAL_CODE_CK: /^(\d{4})$/,
  POSTAL_CODE_CL: /^(\d{7})$/,
  POSTAL_CODE_CN: /^(\d{6})$/,
  POSTAL_CODE_CR: /^(\d{4,5}|\d{3}-\d{4})$/,
  POSTAL_CODE_CS: /^(\d{5})$/,
  POSTAL_CODE_CV: /^(\d{4})$/,
  POSTAL_CODE_CX: /^(6798)$/,
  POSTAL_CODE_CY: /^(\d{4})$/,
  POSTAL_CODE_CZ: /^(\d{3} ?\d{2})$/,
  POSTAL_CODE_DE: /^(\d{5})$/,
  POSTAL_CODE_DK: /^(\d{4})$/,
  POSTAL_CODE_DO: /^(\d{5})$/,
  POSTAL_CODE_DZ: /^(\d{5})$/,
  POSTAL_CODE_EC: /^(([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?)$/,
  POSTAL_CODE_EE: /^(\d{5})$/,
  POSTAL_CODE_EG: /^(\d{5})$/,
  POSTAL_CODE_ES: /^(\d{5})$/,
  POSTAL_CODE_ET: /^(\d{4})$/,
  POSTAL_CODE_FI: /^(\d{5})$/,
  POSTAL_CODE_FK: /^(FIQQ 1ZZ)$/,
  POSTAL_CODE_FM: /^((9694[1-4])([ \-]\d{4})?)$/,
  POSTAL_CODE_FO: /^(\d{3})$/,
  POSTAL_CODE_FR: /^(\d{2} ?\d{3})$/,
  POSTAL_CODE_GB: /^()$/,
  POSTAL_CODE_GE: /^(\d{4})$/,
  POSTAL_CODE_GF: /^(9[78]3\d{2})$/,
  POSTAL_CODE_GG: /^(GY\d[\dA-Z]? ?\d[ABD-HJLN-UW-Z]{2})$/,
  POSTAL_CODE_GL: /^(39\d{2})$/,
  POSTAL_CODE_GN: /^(\d{3})$/,
  POSTAL_CODE_GP: /^(9[78][01]\d{2})$/,
  POSTAL_CODE_GR: /^(\d{3} ?\d{2})$/,
  POSTAL_CODE_GS: /^(SIQQ 1ZZ)$/,
  POSTAL_CODE_GT: /^(\d{5})$/,
  POSTAL_CODE_GU: /^(969[1-3]\d([ \-]\d{4})?)$/,
  POSTAL_CODE_GW: /^(\d{4})$/,
  POSTAL_CODE_HM: /^(\d{4})$/,
  POSTAL_CODE_HN: /^((?:\d{5})?)$/,
  POSTAL_CODE_HR: /^(\d{5})$/,
  POSTAL_CODE_HT: /^(\d{4})$/,
  POSTAL_CODE_HU: /^(\d{4})$/,
  POSTAL_CODE_ID: /^(\d{5})$/,
  POSTAL_CODE_IE: /^(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/,
  POSTAL_CODE_IL: /^\d{5}(\d{2})?$/,
  POSTAL_CODE_IM: /^(IM\d[\dA-Z]? ?\d[ABD-HJLN-UW-Z]{2})$/,
  POSTAL_CODE_IN: /^(\d{6})$/,
  POSTAL_CODE_IO: /^(BBND 1ZZ)$/,
  POSTAL_CODE_IQ: /^(\d{5})$/,
  POSTAL_CODE_IS: /^(\d{3})$/,
  POSTAL_CODE_IT: /^(\d{5})$/,
  POSTAL_CODE_JE: /^(JE\d[\dA-Z]? ?\d[ABD-HJLN-UW-Z]{2})$/,
  POSTAL_CODE_JO: /^(\d{5})$/,
  POSTAL_CODE_JP: /^(\d{3}-\d{4})$/,
  POSTAL_CODE_KE: /^(\d{5})$/,
  POSTAL_CODE_KG: /^(\d{6})$/,
  POSTAL_CODE_KH: /^(\d{5})$/,
  POSTAL_CODE_KR: /^(\d{3}-\d{3})$/,
  POSTAL_CODE_KW: /^(\d{5})$/,
  POSTAL_CODE_KZ: /^(\d{6})$/,
  POSTAL_CODE_LA: /^(\d{5})$/,
  POSTAL_CODE_LB: /^((\d{4}( ?\d{4})?)?)$/,
  POSTAL_CODE_LI: /^((948[5-9])|(949[0-7]))$/,
  POSTAL_CODE_LK: /^(\d{5})$/,
  POSTAL_CODE_LR: /^(\d{4})$/,
  POSTAL_CODE_LS: /^(\d{3})$/,
  POSTAL_CODE_LT: /^(\d{5})$/,
  POSTAL_CODE_LU: /^(\d{4})$/,
  POSTAL_CODE_LV: /^(\d{4})$/,
  POSTAL_CODE_MA: /^(\d{5})$/,
  POSTAL_CODE_MC: /^(980\d{2})$/,
  POSTAL_CODE_MD: /^(\d{4})$/,
  POSTAL_CODE_ME: /^(8\d{4})$/,
  POSTAL_CODE_MG: /^(\d{3})$/,
  POSTAL_CODE_MH: /^(969[67]\d([ \-]\d{4})?)$/,
  POSTAL_CODE_MK: /^(\d{4})$/,
  POSTAL_CODE_MN: /^(\d{6})$/,
  POSTAL_CODE_MP: /^(9695[0-2]([ \-]\d{4})?)$/,
  POSTAL_CODE_MQ: /^(9[78]2\d{2})$/,
  POSTAL_CODE_MT: /^([A-Z]{3} ?\d{2,4})$/,
  POSTAL_CODE_MU: /^((\d{3}[A-Z]{2}\d{3})?)$/,
  POSTAL_CODE_MV: /^(\d{5})$/,
  POSTAL_CODE_MX: /^(\d{5})$/,
  POSTAL_CODE_MY: /^(\d{5})$/,
  POSTAL_CODE_NC: /^(988\d{2})$/,
  POSTAL_CODE_NE: /^(\d{4})$/,
  POSTAL_CODE_NF: /^(2899)$/,
  POSTAL_CODE_NG: /^((\d{6})?)$/,
  POSTAL_CODE_NI: /^(((\d{4}-)?\d{3}-\d{3}(-\d)?)?)$/,
  POSTAL_CODE_NL: /^(\d{4} ?[A-Z]{2})$/,
  POSTAL_CODE_NO: /^(\d{4})$/,
  POSTAL_CODE_NP: /^(\d{5})$/,
  POSTAL_CODE_NZ: /^(\d{4})$/,
  POSTAL_CODE_OM: /^((PC )?\d{3})$/,
  POSTAL_CODE_PF: /^(987\d{2})$/,
  POSTAL_CODE_PG: /^(\d{3})$/,
  POSTAL_CODE_PH: /^(\d{4})$/,
  POSTAL_CODE_PK: /^(\d{5})$/,
  POSTAL_CODE_PL: /^(\d{2}-\d{3})$/,
  POSTAL_CODE_PM: /^(9[78]5\d{2})$/,
  POSTAL_CODE_PN: /^(PCRN 1ZZ)$/,
  POSTAL_CODE_PR: /^(00[679]\d{2}([ \-]\d{4})?)$/,
  POSTAL_CODE_PT: /^(\d{4}(-\d{3})?)$/,
  POSTAL_CODE_PW: /^(96940)$/,
  POSTAL_CODE_PY: /^(\d{4})$/,
  POSTAL_CODE_RE: /^(9[78]4\d{2})$/,
  POSTAL_CODE_RO: /^(\d{6})$/,
  POSTAL_CODE_RS: /^(\d{6})$/,
  POSTAL_CODE_RU: /^(\d{6})$/,
  POSTAL_CODE_SA: /^(\d{5})$/,
  POSTAL_CODE_SE: /^(\d{3} ?\d{2})$/,
  POSTAL_CODE_SG: /^(\d{6})$/,
  POSTAL_CODE_SH: /^((ASCN|STHL) 1ZZ)$/,
  POSTAL_CODE_SI: /^(\d{4})$/,
  POSTAL_CODE_SJ: /^(\d{4})$/,
  POSTAL_CODE_SK: /^(\d{3} ?\d{2})$/,
  POSTAL_CODE_SM: /^(4789\d)$/,
  POSTAL_CODE_SN: /^(\d{5})$/,
  POSTAL_CODE_SO: /^(\d{5})$/,
  POSTAL_CODE_SZ: /^([HLMS]\d{3})$/,
  POSTAL_CODE_TC: /^(TKCA 1ZZ)$/,
  POSTAL_CODE_TH: /^(\d{5})$/,
  POSTAL_CODE_TJ: /^(\d{6})$/,
  POSTAL_CODE_TM: /^(\d{6})$/,
  POSTAL_CODE_TN: /^(\d{4})$/,
  POSTAL_CODE_TR: /^(\d{5})$/,
  POSTAL_CODE_TW: /^(\d{3}(\d{2})?)$/,
  POSTAL_CODE_UA: /^(\d{5})$/,
  POSTAL_CODE_UY: /^(\d{5})$/,
  POSTAL_CODE_UZ: /^(\d{6})$/,
  POSTAL_CODE_VA: /^(120)$/,
  POSTAL_CODE_VE: /^(\d{4})$/,
  POSTAL_CODE_VI: /^(008(([0-4]\d)|(5[01]))([ \-]\d{4})?)$/,
  POSTAL_CODE_WF: /^(986\d{2})$/,
  POSTAL_CODE_XK: /^(\d{5})$/,
  POSTAL_CODE_YT: /^(976\d{2})$/,
  POSTAL_CODE_YU: /^(\d{5})$/,
  POSTAL_CODE_ZA: /^(\d{4})$/,
  POSTAL_CODE_ZM: /^(\d{5})$/,
  STATE: /^[a-zA-Z -]*$/,
  CARD_MONTH: /^(0[1-9]|1[0-2])$/,
  CARD_YEAR: /^(19|20)\d{2}$/,
  CARD_CVV: /^[0-9]{3,4}$/,
  EXTERNAL_ID: /^[a-zA-Z0-9\-_~.]*$/,
}

const STRING_ACCOUNT_NUMBER = {
  format: 'ACCOUNT_NUMBER',
  maxLength: 35,
  minLength: 1,
}

const STRING_ACCOUNT_NUMBER_ACH = {
  format: 'ACCOUNT_NUMBER_ACH',
  maxLength: 17,
  minLength: 6,
}

const STRING_BENEFICIARY_NAME = {
  format: 'BENEFICIARY_NAME',
  maxLength: 70,
  minLength: 1,
}

const STRING_COUNTRY = {
  format: 'ISO31661Alpha2',
}
const STRING_CURRENCY = {
  format: 'currency',
}

const STRING_DATE = {
  format: 'DATE',
}

const STRING_DEFAULT = { minLength: 1, maxLength: 255, format: undefined }

const CREDIT_CARD_DEFAULT = {
  minLength: 13,
  maxLength: 16,
  format: 'CREDIT_CARD',
}

const STRING_EMAIL = {
  format: 'EMAIL',
}

const STRING_NAME = {
  format: 'NAME',
  minLength: 1,
  maxLength: 255,
}

const STRING_PHONE = {
  format: 'PHONE',
}

const STRING_POSTAL_CODE = {
  format: 'POSTAL_CODE',
}

const STRING_POSTAL_CODE_COUNTRY = countryCode => {
  return {
    format: `POSTAL_CODE${countryCode ? `_${countryCode}` : ''}`,
  }
}

const STRING_STATE = {
  format: 'STATE',
}

const STRING_ROUTING_NUMBER_ACH = {
  format: 'ROUTING_NUMBER_ACH',
  maxLength: 9,
  minLength: 9,
}

const STRING_ROUTING_NUMBER_EFT = {
  format: 'ROUTING_NUMBER_EFT',
  maxLength: 9,
  minLength: 9,
}

const STRING_ROUTING_NUMBER_WIRE = {
  format: 'ROUTING_NUMBER_WIRE',
  maxLength: 11,
  minLength: 8,
}

const STRING_SSN_OR_EIN_NUMBER = {
  format: 'SSN_OR_EIN_NUMBER',
  maxLength: 9,
  minLength: 9,
}

const STRING_UUID = {
  format: 'UUID',
}

const STRING_EXTERNAL_ID = {
  format: 'EXTERNAL_ID',
  maxLength: 255,
  minLength: 1,
}

const STRING_ENUM = enums => {
  return {
    format: 'ENUM',
    enums,
  }
}

const CARD_MONTH = {
  format: 'CARD_MONTH',
  minLength: 2,
  maxLength: 2,
}

const CARD_YEAR = {
  format: 'CARD_YEAR',
  minLength: 4,
  maxLength: 4,
}

const CARD_CVV = {
  format: 'CARD_CVV',
  minLength: 3,
  maxLength: 4,
}

const NUMBER_PAYMENT_AMOUNT = {
  minNumber: 1,
  maxNumber: 9999999.99,
}

module.exports = {
  COUNTRY_CODES,
  CREDIT_CARD_DEFAULT,
  CURRENCY,
  REGEX,
  STRING_ACCOUNT_NUMBER,
  STRING_ACCOUNT_NUMBER_ACH,
  STRING_BENEFICIARY_NAME,
  STRING_COUNTRY,
  STRING_CURRENCY,
  STRING_DATE,
  STRING_DEFAULT,
  STRING_EMAIL,
  STRING_NAME,
  STRING_PHONE,
  STRING_POSTAL_CODE, // TODO: deprecate
  STRING_POSTAL_CODE_COUNTRY,
  STRING_STATE,
  STRING_UUID,
  STRING_ROUTING_NUMBER_ACH,
  STRING_ROUTING_NUMBER_EFT,
  STRING_ROUTING_NUMBER_WIRE,
  STRING_SSN_OR_EIN_NUMBER,
  STRING_EXTERNAL_ID,
  STRING_ENUM,
  CARD_MONTH,
  CARD_YEAR,
  CARD_CVV,
  NUMBER_PAYMENT_AMOUNT,
  SUPPORTED_WIRE_COUNTRIES,
  SUPPORTED_CHECK_COUNTRIES,
}
